import publicApiClient from '../publicApiClient';

/**
 * Service for public order operations
 */
export const publicOrderService = {
    /**
     * Get orders for a customer
     * @param {string} customerId - Customer public ID
     * @param {string} supplierId - Supplier public ID
     * @param {number} page - Page number (0-indexed)
     * @param {number} size - Page size
     * @returns {Promise<Array>}
     */
    async getCustomerOrders(customerId, supplierId, page = 0, size = 50, terminal = null) {
        const params = {
            customerId,
            supplierId,
            page,
            size,
            sort: 'createdAt,desc'
        };
        if (terminal !== null) {
            params.terminal = terminal;
        }

        const response = await publicApiClient.get('/public/orders', { params });
        return response.data;
    },

    /**
     * Get a specific order by ID
     * @param {string} orderPublicId - Order public ID
     * @param {string} customerId - Customer public ID
     * @param {string} supplierId - Supplier public ID
     * @returns {Promise<Object>}
     */
    async getOrder(orderPublicId, customerId, supplierId) {
        const params = {
            customerId,
            supplierId
        };

        const response = await publicApiClient.get(`/public/orders/${orderPublicId}`, { params });
        return response.data;
    },

    /**
     * Place a new order
     * @param {Object} request - Order request
     * @param {string} request.supplierPublicId - Supplier public ID
     * @param {string} request.customerPublicId - Customer public ID
     * @param {string} request.deliveryDate - Delivery date (ISO format)
     * @param {string} request.timeSlot - Time slot
     * @param {Array} request.items - Order items [{productPublicId, quantity}]
     * @returns {Promise<Object>}
     */
    async placeOrder(request) {
        const response = await publicApiClient.post('/public/orders', request);
        return response.data;
    }
};
